// Privacy.jsx
import React from 'react';
import LegalLayout from './LegalLayout';

const Privacy = () => (
  <LegalLayout title="Privacy Policy" lastUpdated="22 September 2026">
    <h2>1. Data We Collect &amp; Lawful Basis</h2>
    <p>
      We process personal data strictly under the principles of data minimisation (GDPR Art. 5(1)(c)).
      The personal data we collect is limited to:
    </p>
    <ul>
      <li>
        <strong>Email Address:</strong> Processed under <em>Performance of a Contract (GDPR Art. 6(1)(b))</em> to authenticate logins and deliver service notifications. Corporate email domains (e.g., <code>@goaheadlondon.com</code>, <code>@ratpdev.com</code>) are processed under <em>Legitimate Interest (GDPR Art. 6(1)(f))</em> to match users with their authorized bus operator network.
      </li>
      <li>
        <strong>Hashed Passwords:</strong> Processed under <em>Performance of a Contract</em> to secure account access using modern one-way cryptographic hashing algorithms.
      </li>
    </ul>

    <h2>2. Location &amp; Telemetry</h2>
    <p>
      All vehicle location data processed across our service is non‑personally identifiable operational telemetry derived from public transit feeds (Transport for London). We do not track or record individual users’ physical locations.
    </p>

    <h2>3. Sub-Processors &amp; Data Sharing</h2>
    <p>
      We do not sell, rent, or trade your personal data. We share data strictly with third-party service providers (sub-processors) necessary to maintain the application:
    </p>
    <ul>
      <li><strong>Stripe:</strong> Payment processing and billing operations.</li>
      <li><strong>Cloud Infrastructure Providers (AWS / Vercel / Heroku):</strong> Secure database storage and backend API execution.</li>
    </ul>

    <h2>4. Data Retention &amp; Erasure</h2>
    <p>
      Your data is retained for the active lifespan of your account. Inactive accounts are automatically purged after 24 consecutive months. You may exercise your right to erasure at any time via account settings or by emailing our privacy team. Backups are fully overwritten on a rolling 30-day schedule.
    </p>

    <h2>5. Your Rights &amp; Contact</h2>
    <p>
      Under GDPR, you hold the right to access, rectify, restrict, or delete your personal data. To exercise these rights, contact our Data Protection Officer at{' '}
      <a href="mailto:privacy@drivenby.com">privacy@drivenby.com</a>.
    </p>
  </LegalLayout>
);

export default Privacy;